if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    
	if(document.getElementById('attractions')){
		setTimeout(function(){
			if(document.getElementsByClassName('btn').length > 0){
				convertBtn();
			}
		}, 600)
	} else {
		if(document.getElementsByClassName('btn').length > 0){
			convertBtn();
		}
	}


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

	$('.gallery-simple').slick({
		accessibility: false,
		centerMode:true,
		centerPadding:'360px',
		slidesToShow:1,
		responsive: [
			{
			  breakpoint: 1100,
			  settings: {
				centerPadding:'200px', 
			  }
			},
			{
				breakpoint: 1000,
				settings: {
					centerPadding:'100px', 
				}
			},
			{
				breakpoint: 600,
				settings: {
					centerPadding:'40px', 
				}
			}
		]
	})

	$('.team-slides').slick({
		fade:true,
		accessibility:false
	})

	//team shortcode scripts
	if(document.getElementsByClassName('js-team-item').length > 0){
		let allTeam = document.getElementsByClassName('js-team-item');
		for (let item of allTeam) {
			item.addEventListener('click', function(){
				let currentIndex = this.getAttribute('data-index');
				$('.team-slides').slick('slickGoTo',currentIndex);
				for (let item of allTeam) {
					item.classList.remove('active');
				}
				this.classList.add('active')
			})
		}
		$('.team-slides').on('beforeChange', function(event, slick, currentSlide,nextSlide){
			for(let i = 0; i < allTeam.length; i++) {
				if(i == nextSlide){
					document.getElementsByClassName('js-team-item')[i].classList.add('active');
				} else {
					document.getElementsByClassName('js-team-item')[i].classList.remove('active');
				}
			}
			
		});
	}
	
	


    //email signup animation 
	if(document.getElementById('email-signup_email_address')){
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
	}
	
    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.parentElement.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
	   }
	}

    

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}
	}


})();

function convertBtn(){
	
	let allBtn = document.getElementsByClassName('btn');
	let allBtnLength = allBtn.length;
	for(let h = 0; h < allBtnLength; h++){
		let InnerText = '';
		if(!allBtn[h].parentElement.classList.contains('form-module__submit')){ // cms form adds extra span
			InnerText = allBtn[h].innerHTML;
			allBtn[h].innerHTML = '<span>'+InnerText+'</span>'
		}
	}
    
}